import { render, staticRenderFns } from "./LogOutComponent.vue?vue&type=template&id=4582374d&"
import script from "./LogOutComponent.vue?vue&type=script&lang=ts&"
export * from "./LogOutComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LogOutComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports